import { motion } from "framer-motion";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-28 md:py-36 overflow-hidden"
    >
      <div className="vs-container relative z-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9 }}
            className="lg:col-span-4"
          >
            <div className="flex items-center gap-3">
              <span className="h-px w-10 bg-[#d4af37]" />
              <span className="text-overline">About VerySight</span>
            </div>
            <h2 className="mt-6 font-serif-display text-4xl md:text-5xl leading-[1.05] tracking-tight text-white">
              The story
              <br />
              behind your
              <br />
              <span className="italic vs-gold-text">numbers.</span>
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, delay: 0.15 }}
            className="lg:col-span-8 space-y-8"
          >
            <p className="font-serif-display text-2xl md:text-3xl leading-snug text-white/90">
              Financial reports don&apos;t improve businesses.
              <br />
              The decisions made from them do.
            </p>
            <div className="grid md:grid-cols-2 gap-8 pt-6 border-t border-white/10">
              <p className="text-white/70 font-body leading-relaxed">
                Most businesses already have accountants, bookkeepers and finance managers.
                They keep the records straight — VAT, payroll, audits, statutory filings.
                Necessary work. Not the same as financial intelligence.
              </p>
              <p className="text-white/70 font-body leading-relaxed">
                VerySight is the independent CFO voice that reads between the lines. We turn
                statements into narrative, patterns into priorities, and priorities into the
                two or three decisions that will actually move the business.
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 pt-8">
              {[
                { k: "Independent", v: "Advisory" },
                { k: "Owner-first", v: "Voice" },
                { k: "Strategy over", v: "Reporting" },
                { k: "Boutique &", v: "Discreet" },
              ].map((c) => (
                <div key={c.k} className="border-l border-white/15 pl-4">
                  <div className="text-[10px] tracking-widest text-white/45 uppercase font-body">
                    {c.k}
                  </div>
                  <div className="font-serif-display text-xl text-white mt-1">{c.v}</div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
